import styled from "styled-components";


export const WizSelectStyles = styled.div`
  .wiz-select__menu {
    z-index: 40;
    color: black;
  }
`;